// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1cjNY","validationTips":"StatementDescriptor_validationTips__3MJSE"};